<h2 class="titulo" mat-dialog-title>
  <span></span>
  <button class="not-print" mat-dialog-close mat-icon-button>
    <mat-icon fontSet="material-icons-outlined">close</mat-icon>
  </button>
</h2>

<mat-dialog-content #resumoDiv class="outer-container">
  <table class="dialog-table">
    <thead>
      <tr>
        <th *ngFor="let header of listaFields">{{ header.label }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of visitas">
        <td *ngFor="let cell of row">{{ getValue(cell) }}</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end" class="not-print">
  <button mat-raised-button color="primary" (click)="baixarXls()">Baixar XLS</button>
  <button mat-raised-button color="accent" (click)="print()">Imprimir</button>
</mat-dialog-actions >
